<template>
  <div>
    <div v-if="documentData.badges.length">
      <div
        v-for="badge in documentData.badges"
        :key="badge.label"
        class="dte-banner"
        :class="`dte-banner--${badge.tone}`"
      >
        {{ badge.label }}
      </div>
    </div>

    <div class="dte-header-layout">
      <div class="dte-header-layout__issuer">
        <section class="dte-card dte-header-layout__issuer-card">
          <div class="dte-card__body dte-business-card">
            <div v-if="compact">
              <div class="dte-business-card__media dte-business-card__media--row">
                <img
                  v-if="documentData.issuer.logoUrl"
                  :src="documentData.issuer.logoUrl"
                  alt="Logo emisor"
                  class="dte-logo"
                />
              </div>

              <div class="dte-definition-list dte-business-card__info">
                <div class="dte-definition-list__row dte-definition-list__row--single" v-if="documentData.issuer.billedInfoText">
                  <span style="white-space: pre-line;">
                    {{ documentData.issuer.billedInfoText }}
                  </span>
                </div>
                <template v-else>
                  <div class="dte-definition-list__row">
                    <dt>Negocio</dt>
                    <dd>{{ documentData.issuer.businessName }}</dd>
                  </div>
                  <div class="dte-definition-list__row" v-if="documentData.issuer.tradeName">
                    <dt>Razon social</dt>
                    <dd>{{ documentData.issuer.tradeName }}</dd>
                  </div>
                  <div class="dte-definition-list__row" v-if="documentData.issuer.activity">
                    <dt>Actividad</dt>
                    <dd>{{ documentData.issuer.activity }}</dd>
                  </div>
                  <div class="dte-definition-list__row" v-if="documentData.issuer.address">
                    <dt>Direccion</dt>
                    <dd>
                      <span>{{ documentData.issuer.address }}</span>
                    </dd>
                  </div>
                  <div class="dte-definition-list__row" v-if="contactLine">
                    <dt>Contacto</dt>
                    <dd>
                      {{ contactLine }}
                    </dd>
                  </div>
                  <div class="dte-definition-list__row">
                    <dt>NIT / NRC</dt>
                    <dd>{{ documentData.issuer.nit }} / {{ documentData.issuer.nrc }}</dd>
                  </div>
                </template>
              </div>
            </div>

            <div v-else class="dte-business-card__columns">
              <div class="dte-business-card__main">
                <div class="dte-business-card__media dte-business-card__media--row">
                  <img
                    v-if="documentData.issuer.logoUrl"
                    :src="documentData.issuer.logoUrl"
                    alt="Logo emisor"
                    class="dte-logo"
                  />
                </div>

                <div class="dte-definition-list dte-business-card__info">
                  <div class="dte-definition-list__row dte-definition-list__row--single" v-if="documentData.issuer.billedInfoText">
                    <span style="white-space: pre-line;">
                      {{ documentData.issuer.billedInfoText }}
                    </span>
                  </div>
                  <template v-else>
                    <div class="dte-definition-list__row">
                      <dt>Negocio</dt>
                      <dd>{{ documentData.issuer.businessName }}</dd>
                    </div>
                    <div class="dte-definition-list__row" v-if="documentData.issuer.tradeName">
                      <dt>Razon social</dt>
                      <dd>{{ documentData.issuer.tradeName }}</dd>
                    </div>
                    <div class="dte-definition-list__row" v-if="documentData.issuer.activity">
                      <dt>Actividad</dt>
                      <dd>{{ documentData.issuer.activity }}</dd>
                    </div>
                    <div class="dte-definition-list__row" v-if="documentData.issuer.address">
                      <dt>Direccion</dt>
                      <dd>
                        <span>{{ documentData.issuer.address }}</span>
                      </dd>
                    </div>
                    <div class="dte-definition-list__row" v-if="contactLine">
                      <dt>Contacto</dt>
                      <dd>
                        {{ contactLine }}
                      </dd>
                    </div>
                    <div class="dte-definition-list__row">
                      <dt>NIT / NRC</dt>
                      <dd>{{ documentData.issuer.nit }} / {{ documentData.issuer.nrc }}</dd>
                    </div>
                  </template>
                </div>
              </div>

              <div class="dte-business-card__qr-column">
                <img
                  v-if="documentData.qrImage"
                  :src="documentData.qrImage"
                  alt="QR documento"
                  class="dte-qrcode dte-qrcode--inline dte-qrcode--emitter"
                />
                <div
                  v-else
                  class="dte-qrcode dte-qrcode--inline dte-qrcode--emitter dte-qrcode--placeholder"
                  aria-hidden="true"
                ></div>
              </div>
            </div>
          </div>
        </section>

      </div>

      <section
        v-if="compact"
        class="dte-card dte-header-layout__qr"
      >
        <div class="dte-card__body dte-header-layout__qr-body">
          <img
            v-if="documentData.qrImage"
            :src="documentData.qrImage"
            alt="QR documento"
            class="dte-qrcode dte-qrcode--compact-header"
          />
          <div
            v-else
            class="dte-qrcode dte-qrcode--compact-header dte-qrcode--compact-placeholder"
            aria-hidden="true"
          ></div>
        </div>
      </section>

      <section class="dte-card dte-header-layout__meta">
        <div class="dte-card__header dte-card__header--centered dte-card__header--document-title">{{ documentData.meta.invoiceTypeLabel }}</div>
        <div class="dte-card__body dte-metadata dte-document-card">
          <div class="dte-definition-list dte-document-card__info">
            <div class="dte-definition-list__row">
              <dt>Codigo generacion</dt>
              <dd>{{ documentData.meta.generationCode }}</dd>
            </div>
            <div class="dte-definition-list__row">
              <dt>Sello recepcion</dt>
              <dd>{{ documentData.meta.receiptSeal }}</dd>
            </div>
            <div v-if="showControlNumber" class="dte-definition-list__row">
              <dt>Numero control</dt>
              <dd>{{ documentData.meta.controlNumber }}</dd>
            </div>
            <div class="dte-definition-list__row">
              <dt>Correlativo</dt>
              <dd>{{ documentData.meta.invoiceId }}</dd>
            </div>
            <div class="dte-definition-list__row">
              <dt>Fecha emision</dt>
              <dd>{{ documentData.meta.issueDate }}</dd>
            </div>
            <div class="dte-definition-list__row" v-if="showDueDate">
              <dt>{{ dueDateLabel }}</dt>
              <dd>{{ documentData.meta.dueDate }}</dd>
            </div>
            <div class="dte-definition-list__row">
              <dt>Modelo</dt>
              <dd>{{ documentData.meta.modelLabel }}</dd>
            </div>
            <div class="dte-definition-list__row">
              <dt>Transmision</dt>
              <dd>{{ documentData.meta.transmissionLabel }}</dd>
            </div>
          </div>

        </div>
      </section>
    </div>

    <section v-if="showInlineBanner" class="dte-banner-card">
      <img
        :src="documentData.issuer.bannerUrl"
        alt="Banner emisor"
        class="dte-banner-image"
      />
    </section>
  </div>
</template>

<script>
import {
  getDteTemplateLabel,
  isDteTemplateFieldVisible,
} from "@/helpers/dteTemplateSettings";

export default {
  name: "DtePageHeaderSection",
  props: {
    documentData: {
      type: Object,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    templateSettings() {
      return this.documentData.templateSettings || {};
    },
    contactLine() {
      return [
        this.documentData.issuer.phone
          ? `${this.documentData.issuer.phoneLabel} ${this.documentData.issuer.phone}`
          : "",
        this.documentData.issuer.mobile,
        this.documentData.issuer.email
          ? `${this.documentData.issuer.emailLabel} ${this.documentData.issuer.email}`
          : "",
      ]
        .filter(Boolean)
        .join(" | ");
    },
    showDueDate() {
      return (
        Boolean(this.documentData.meta.dueDate) &&
        isDteTemplateFieldVisible(this.templateSettings, "document", "dueDate") &&
        !this.isContadoEspecial
      );
    },
    dueDateLabel() {
      return getDteTemplateLabel(this.templateSettings, "dueDate", "Fecha vencimiento");
    },
    showInlineBanner() {
      return Boolean(this.documentData.showInlineBanner);
    },
    showControlNumber() {
      return this.documentData?.meta?.invoiceType !== "FER" && Boolean(this.documentData?.meta?.controlNumber);
    },
    isContadoEspecial() {
      const diasCredito = this.diferentBetweenDays(
          this.documentData.meta.issueDate,
          this.documentData.meta.dueDate
      );

      const user = JSON.parse(localStorage.getItem("user") || "{}");

      return (
        user?.showcashinvoiceswhen1day &&
        this.documentData?.meta?.paymentStatus === "Crédito" &&
        diasCredito === 1
      );
    },
  },
  methods: {
    diferentBetweenDays(date1, date2) {
        const [d1, m1, a1] = date1.split('/').map(Number);
        const [d2, m2, a2] = date2.split('/').map(Number);

        const f1 = new Date(a1, m1 - 1, d1);
        const f2 = new Date(a2, m2 - 1, d2);

        const diferenciaMs = Math.abs(f2 - f1);
        return Math.floor(diferenciaMs / (1000 * 60 * 60 * 24));
    }
  }
};
</script>
